import React, { useState } from 'react';
import { Container } from 'reactstrap';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import ResetCurrentPasswordForm from './components/ResetPassword';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { ERROR_MESSAGES, LOGIN_HUB_USER_IDENTIFIER } from 'src/utils/pnd/PndConstants';

const ResetCurrentPassword = () => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formValues, dispatch, props) => {
    try {
      setLoading(true);
      if (formValues['password'] !== formValues['confirmPassword']) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: 500`,
          `Message: Password must match`,
        );
        return;
      }
 
      const uppercaseRegExp = /(?=.*?[A-Z])/;
      const lowercaseRegExp = /(?=.*?[a-z])/;
      const digitsRegExp = /(?=.*?[0-9])/;
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
      const minLengthRegExp = /.{8,}/;
      const uppercasePassword = uppercaseRegExp.test(formValues["password"]);
      const lowercasePassword = lowercaseRegExp.test(formValues["password"]);
      const digitsPassword = digitsRegExp.test(formValues["password"]);
      const specialCharPassword = specialCharRegExp.test(formValues["password"]);
      const minLengthPassword = minLengthRegExp.test(formValues["password"]);
      if (!uppercasePassword || !lowercasePassword || !digitsPassword || !specialCharPassword || !minLengthPassword) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: 500`,
          `Message: Password must include at least one lowercase letter, one uppercase letter, one special character, one digit and must be at least 8 characters long.`,
        );
        return;
      }

      if (formValues["currentPassword"] === formValues["password"]) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: 500`,
          `Message: Please choose a different password. New password cannot be the same as your current one.`,
        );
        return;
      }

      let formData = new FormData();    // formdata object
      formData.append('password', formValues["currentPassword"]); 
      formData.append('newPassword', formValues["password"]);
      formData.append('userId', localStorage.getItem('ui'));
      formData.append('type', LOGIN_HUB_USER_IDENTIFIER); // client admin

      if (formData && formData !== null) {
        const response = await PndRestApi.ChangePassword(formData);
        if (response.status === 200 && response.data.status === 200) {
          successNofication(
            "theme-light",
            "ltr",
            `SuccessCode: 200`,
            `Message: Password Changed Successfully`,
          );
          props.reset(); // Reset the form after successful submission
        } else {
          showNotification(
            "theme-light",
            "ltr",
            `SuccessCode: ${response.data.status}`,
            `Message: ${response.data.message}`,
          );
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <ResetCurrentPasswordForm onSubmit={handleSubmit} />
    </Container>
  );
};

export default ResetCurrentPassword;
